import React from 'react'

const GreenStarIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.30005 16.6246C3.91672 16.9246 3.52505 16.9329 3.12505 16.6496C2.72505 16.3663 2.59172 15.9913 2.72505 15.5246L4.15005 10.8996L0.525053 8.32461C0.125053 8.04128 0.00438659 7.66628 0.163053 7.19961C0.321053 6.73294 0.64172 6.49961 1.12505 6.49961H5.60005L7.05005 1.69961C7.13339 1.46628 7.26272 1.28694 7.43805 1.16161C7.61272 1.03694 7.80005 0.974609 8.00005 0.974609C8.20005 0.974609 8.38739 1.03694 8.56205 1.16161C8.73739 1.28694 8.86672 1.46628 8.95005 1.69961L10.4001 6.49961H14.8751C15.3584 6.49961 15.6794 6.73294 15.8381 7.19961C15.9961 7.66628 15.8751 8.04128 15.4751 8.32461L11.8501 10.8996L13.2751 15.5246C13.4084 15.9913 13.2751 16.3663 12.8751 16.6496C12.4751 16.9329 12.0834 16.9246 11.7001 16.6246L8.00005 13.7996L4.30005 16.6246Z"
        fill="#5DB594"
      />
    </svg>
  )
}

export default GreenStarIcon
